import { ieHelpers } from './'

let prefix = 'om.'

/**
 * Set the custom event prefix. Defaults to "om.".
 *
 * @since 0.1.2
 *
 * @param   {string}  pre The custom event prefix to use.
 */
export function setPrefix(pre = prefix) {
	prefix = pre
}

/**
 * This allows us to trigger a custom event.
 *
 * @since 0.1.2
 *
 * @param   {string}  event The "event" that we are going to listen to, this will be prefixed with "om.".
 * @param   {Object}  data  An object of data that will be available in the event.detail property.
 * @param   {Element} el    The element we are adding an event to. Defaults to the document.
 * @returns {void}
 */
export function trigger(event, data = {}, el = document) {
	let c  = event[0] !== event[0].toLowerCase(),
		evt = null

	if (c) {
		if (ieHelpers.isIe()) {
			evt = document.createEvent('CustomEvent')
			evt.initCustomEvent(prefix + event, true, true, data)
		} else {
			evt = new CustomEvent(prefix + event, {
				bubbles    : true,
				cancelable : true,
				detail     : data
			})
		}
	} else {
		if (ieHelpers.isIe()) {
			evt = document.createEvent('HTMLEvents')
			evt.initEvent(event, true, true)
		} else {
			evt = new Event(event, {
				bubbles    : true,
				cancelable : true
			})
		}
	}

	// Dispatch the event.
	el.dispatchEvent(evt)
}
